import { APPLICATION_ERROR, LOCATE_USER_LOADING, SHOW_REQUEST_TOKEN, USER_NOT_FOUND } from '../../reducers/loginReducers';
import { post } from '../../utils/api';
import { LOGIN, OAUTH } from '../../utils/Links';

const fetchUserDetailsAction = params => ({
  urlName: LOGIN,
  loaded: SHOW_REQUEST_TOKEN,
  initiate: LOCATE_USER_LOADING,
  failure: USER_NOT_FOUND,
  params,
});

const determineWhichActionToDispatchFrom = (response) => {
  if (response && response.status === 401) {
    return USER_NOT_FOUND;
  }
  return APPLICATION_ERROR;
};

export const retrieveOAuth = (url, body) => dispatch => post(url, body)
  .then(() => dispatch(fetchUserDetailsAction(body)))
  .catch((error) => {
    const actionToDispatch = determineWhichActionToDispatchFrom(error.response);
    dispatch({ type: actionToDispatch, response: error.response ? error.response.data : {} });
  });

const fetchOAuth = params => ({
  urlName: OAUTH,
  fetch: retrieveOAuth,
  initiate: LOCATE_USER_LOADING,
  failure: USER_NOT_FOUND,
  params,
});

export const fetchUserDetails = body => dispatch => dispatch(fetchOAuth(body));
